export const locationDa = [
  {
    places: "Rs Puram",
    count: 209,
  },
  {
    places: "Rs Puram",
    count: 209,
  },
  {
    places: "Rs Puram",
    count: 209,
  },
  {
    places: "Rs Puram",
    count: 209,
  },
  {
    places: "Rs Puram",
    count: 209,
  },
  {
    places: "Rs Puram",
    count: 209,
  },
  {
    places: "Rs Puram",
    count: 209,
  },
  {
    places: "Rs Puram",
    count: 209,
  },

  {
    places: "Rs Puram",
    count: 209,
  },
];
